var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid25({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,7.89a5,5,0,0,1,.36-2,3.74,3.74,0,0,1,.73-1.08,3.1,3.1,0,0,1,1-.7A4.3,4.3,0,0,1,8,3.77a3.68,3.68,0,0,1,2.78,1.08,4.13,4.13,0,0,1,1.05,3,4.13,4.13,0,0,1-1,3A3.65,3.65,0,0,1,8,11.92a3.71,3.71,0,0,1-2.79-1.07A4.09,4.09,0,0,1,4.2,7.89Zm1.64,0a2.92,2.92,0,0,0,.62,2A2,2,0,0,0,8,10.56a2,2,0,0,0,1.56-.69,3,3,0,0,0,.61-2,2.94,2.94,0,0,0-.59-2A2,2,0,0,0,8,5.13a2,2,0,0,0-1.58.68A3,3,0,0,0,5.84,7.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid25);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_25.e1e9831b13fa8a86b8f366097c444288.svg";
export { ForwardRef as ReactComponent };